import * as React from "react";
import { observer } from "mobx-react";
import { ThemeProvider, SegmentedControl, Box, Layout } from "@draftkings/arena-web";
import { MyBetsHeaderWithContent, LoadingBetsScreen, UnauthorizedScreen, NoBetsScreen, BetsChunk, LazyLoad, } from "../components";
import { SportsbookContext } from "../contexts";
import { getFunctionHandler } from "../../../constants";
import { getSegmentedControlProps } from "./getSegmentedControlProps";
const bounceAnimation = `
@keyframes bounce {
    from {
        margin-left: 0%;
    }

    to {
        margin-left: 57%;
    }
}`;
const selectors = `
    #layout-wrapper {
        overflow: hidden;
    }
`;
const myBetsListStateStatusesMap = new Proxy({
    Initial: LoadingBetsScreen,
    Loading: LoadingBetsScreen,
    Unauthorized: UnauthorizedScreen,
    Loaded: NoBetsScreen,
    BetsEnd: NoBetsScreen,
    GeneralError: LoadingBetsScreen,
}, getFunctionHandler);
class MyBetsListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = props.dataProvider;
        this.statusScreenOnClickMap = new Proxy({
            Unauthorized: this.state.openLogin,
            Loaded: this.state.openGameLines,
            BetsEnd: this.state.openGameLines,
        }, getFunctionHandler);
    }
    render() {
        const StatusScreen = myBetsListStateStatusesMap[this.state.status];
        const segmentedControlProps = getSegmentedControlProps({
            status: this.state.status,
            filters: this.state.config.statusFilterLabels,
            selectedIndex: this.state.selectedStatusFilterIndex,
            onClick: this.state.changeStatusFilter,
        });
        return (React.createElement(ThemeProvider, { theme: this.props.theme },
            React.createElement("style", null,
                bounceAnimation,
                " ",
                selectors),
            React.createElement(SportsbookContext.Provider, { value: {
                    getIcon: this.state.getIcon,
                    dictionary: this.state.dictionary,
                    getNavLink: this.state.getNavLink,
                    openEarlyExitTagModal: this.state.openEarlyExitTagModal,
                } },
                React.createElement(MyBetsHeaderWithContent, { myBetsHeader: this.state.dictionary.myBetsDictionary.MyBets },
                    React.createElement(Box, null,
                        React.createElement(SegmentedControl, Object.assign({}, segmentedControlProps))),
                    React.createElement(Layout, { variant: "myBetsContent", id: 'layout-wrapper' },
                        React.createElement(LazyLoad, { hasMoreContent: this.state.hasMoreBetsToLoad, loadMoreContent: this.state.loadMoreBets }, this.state.betsChunks.length > 0
                            //TODO: remove LazyLoad/LazyRender and use component/s from shared library that is to be developed - https://jira.dkcorpit.com/browse/SB-24657
                            //same as dk-same-game-parlay blocks
                            ? React.createElement(React.Fragment, null,
                                this.state.betsChunks.map((chunk, index) => React.createElement(BetsChunk, Object.assign({ key: `chunk-${index}` }, chunk, { chunkIndex: index, setActualChunkHeight: this.state.setActualChunkHeight }))),
                                this.state.status === "Loading" && React.createElement(LoadingBetsScreen, { loadingBetCardsCount: 6 }))
                            : React.createElement(StatusScreen, { dictionary: this.state.dictionary, onClick: this.statusScreenOnClickMap[this.state.status], loadingBetCardsCount: 6 })))))));
    }
}
export const MyBetsList = observer(MyBetsListComponent);
//# sourceMappingURL=MyBetsList.js.map